import {Controller} from "@hotwired/stimulus";

export default class extends Controller {

  static targets = ["hiddenInput", "storeCard"]

  handleClick(e) {
    const old_store = JSON.parse(this.hiddenInputTarget.value)
    const old_id = old_store?.keynest_id
    const new_store = JSON.parse(e.currentTarget.dataset.store)
    const new_id = new_store.keynest_id

    if (old_id && (old_id !== new_id)) {
      const old_card = this.storeCardTargets.find(card => card.id === old_id)
      old_card && old_card.classList.toggle("bg-brand-100")
    }
    const new_card = this.storeCardTargets.find(card => card.id === new_id)
    new_card && new_card.classList.toggle("bg-brand-100")

    this.hiddenInputTarget.value = JSON.stringify(new_store)
  }
}
